<template>
<div class="columns is-gap is-multiline margin_gap">
  <div v-for="(faceLc, index) in detailPanneauxLc"
    :key="index"
    class="column is-half-tablet is-one-third-desktop">
    <div :class="{'selectt': faceLc.select}" class="is-height-per">
      <div class="columns is-mobile is-marginless">
        <div class="column is-relative is-paddingless is-height-200">
          <img :src="url(faceLc.extensionOpportunite.urlPhoto)" class="imageBg" alt="">
          <div @click="afficheFace(index)" class="pointer level bgBande">
            <div class="has-text-white">
              <div
                v-if="faceLc.extensionOpportunite.duree"
                class="media">
                <b-icon
                  icon="timer"
                  size="is-medium"
                  class="media-left margin_small">
                </b-icon>
                <div class="media-content is-size-7">
                  <label> Durée : </label>
                  <p class="p_size14 has-text-weight-bold">
                    {{faceLc.extensionOpportunite.duree}}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="level-right"
              v-if="getTarif">
              <p class="p_size18 has-text-weight-bold has-text-white goToLeft">
                {{tarifAnnuel(getTarif(faceLc))}}
                {{faceLc.extensionOpportunite.tarifInformation}} HT
              </p>
            </div>
          </div>
        </div>
        <div class="column is-narrow espace-icon pb-0">
          <div class="has-text-centered mb-btnaction">
            <div class="icon-forme pointer" :class="{'icon-select': faceLc.select}"
              @click="contolSelect(index)">
              <b-icon icon="cart"
              type="is-white" custom-class="icon-position"></b-icon>
            </div>
            <p class="p_size10 has-text-default ml-5px" v-if="!faceLc.select">
              Sélectionner</p>
            <p class="p_size10 has-text-default ml-5px" v-else>
              Retirer</p>
          </div>
          <div class="has-text-centered mb-btnaction ">
            <div class="icon-forme pointer topViolet" @click="afficheFace(index)">
              <b-icon icon="information"
              type="is-white" custom-class="icon-position"></b-icon>
            </div>
            <p class="p_size10 has-text-default ml-5px">
              Plus d'infos</p>
          </div>
        </div>
      </div>
      <div @click="afficheFace(index)" class="pointer infoBorder has-background-white
        height-calc-auto">
        <div class="leftViolet topViolet rightViolet bottomVert">
          <label class="has-text-default"> Adresse </label>
          <p class="has-text-dark has-text-weight-bold p_size14">
            {{adresse(faceLc)}}
          </p>
        </div>
        <div class="column leftViolet rightViolet">
          <div class="columns is-multiline color-icon">
            <div class="column bottomVert is-paddingless is-6">
              <div class="media">
                <b-icon
                  icon="vector-intersection"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">
                    Format
                  </label>
                  <p class="p_size14 has-text-weight-bold has-text-link">
                    {{faceLc.format}}
                  </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-6">
              <div class="media">
                <b-icon
                  icon="sign-text"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">
                    Support
                  </label>
                  <p class="p_size14 has-text-weight-bold has-text-link">
                    {{faceLc.support}}
                  </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-6">
              <div class="media">
                <b-icon
                  icon="lightbulb-on-outline"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">
                    Éclairé
                  </label>
                  <p class="p_size14 has-text-weight-bold has-text-link">
                    {{eclaire(faceLc.eclaire)}}
                  </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-6">
              <div
                v-if="faceLc.extensionOpportunite.dateDisponibilite"
                class="media">
                <b-icon
                  icon="calendar-check"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">
                    Date de début
                  </label>
                  <p class="p_size14 has-text-weight-bold has-text-link">
                    {{dateDisponibilite(faceLc.extensionOpportunite.dateDisponibilite)}}
                  </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-12">
              <div
                v-if="faceLc.extensionOpportunite.commentaire"
                class="media">
                <div class="media-content">
                  <label class="has-text-weight-bold has-text-link p_size14">
                    Commentaire :
                  </label>
                  <p class="has-text-default p_size12">
                    {{faceLc.extensionOpportunite.commentaire}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <transition
    name="custom-classes-transition"
    enter-active-class="animated slideInRight"
    leave-active-class="animated slideOutRight"
    :duration="300"
    v-on:after-enter="bg = true"
    v-on:after-leave="bg = false">
    <app-detail-opportunites :bg="bg" :detailFaceLc="detailFaceLc" v-if="show"/>
  </transition>
</div>
</template>

<script>
import { mapActions } from 'vuex';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import { formatAdresse, formatNum, formatEclaire, formatDate, urlPhoto } from '@/services/opportunite/formatTab';
import detailOpportunites from './detailOpportunites';

export default {
  name: 'listeFacesLc',
  props: ['detailPanneauxLc'],
  components: {
    appDetailOpportunites: detailOpportunites,
  },
  data() {
    return {
      show: false,
      detailFaceLc: {},
      bg: false,
      select: -1,
    };
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect(i) {
      this.detailPanneauxLc[i].select = !this.detailPanneauxLc[i].select;
      if (this.detailPanneauxLc[i].select) {
        this.detailPanneauxLc[i].icon = iconColorGetter('#49db70', TAILLE_ICON_GRAND);
        this.add(this.getTarif(this.detailPanneauxLc[i]));
        this.addNbSelect();
      } else {
        this.detailPanneauxLc[i].icon = iconColorGetter('#009ce0', TAILLE_ICON_GRAND);
        this.substract(this.getTarif(this.detailPanneauxLc[i]));
        this.substractNbSelect();
      }
    },
    afficheFace(i) {
      this.detailFaceLc = this.detailPanneauxLc[i];
      this.show = true;
    },
    adresse(data) {
      return formatAdresse(data);
    },
    tarifAnnuel(t) {
      return formatNum(t);
    },
    eclaire(e) {
      return formatEclaire(e);
    },
    dateDisponibilite(d) {
      return formatDate(d);
    },
    url(u) {
      return urlPhoto(u);
    },
    getTarif(data) {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let fraisTechnique = 0;
      let tarifAnnuel = 0;
      if (data.extensionOpportunite.tarifDePose) {
        tarifDePose = data.extensionOpportunite.tarifDePose;
      }
      if (data.extensionOpportunite.taxeMunicipale) {
        taxeMunicipale = data.extensionOpportunite.taxeMunicipale;
      }
      if (data.extensionOpportunite.fraisTechnique) {
        fraisTechnique = data.extensionOpportunite.fraisTechnique;
      }
      if (data.extensionOpportunite.tarifAnnuel) {
        tarifAnnuel = data.extensionOpportunite.tarifAnnuel;
      }
      if (data.extensionOpportunite.tarifNet) {
        tarifNet = data.extensionOpportunite.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
      }
      return tarifAnnuel
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/panneauxLc/listesFacesLc.vue